// extracted by mini-css-extract-plugin
export default {"inputRoot":"Input_inputRoot__fi3kA","label":"Input_label__Dz5N0","input":"Input_input__eXwaT","errorText":"Input_errorText__+pQQJ"};